var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: "清关要素",
        visible: _vm.dialogVisible,
        width: "1033px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "content",
        },
        [
          _c("div", { staticClass: "nav" }, [
            _c(
              "div",
              {
                staticClass: "nav-item",
                class: _vm.renderClass("PRE_CLEARANCE"),
              },
              [
                _c("div", { staticClass: "icon" }, [
                  _c("i", { staticClass: "el-icon-check" }),
                ]),
                _c("span", [_vm._v("清关前")]),
                _c("div", { staticClass: "line" }),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "nav-item",
                class: _vm.renderClass("IN_CLEARANCE"),
              },
              [
                _c("div", { staticClass: "icon" }, [
                  _c("i", { staticClass: "el-icon-check" }),
                ]),
                _c("span", [_vm._v("清关中")]),
                _c("div", { staticClass: "line" }),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "nav-item",
                class: _vm.renderClass("POST_CLEARANCE"),
              },
              [
                _c("div", { staticClass: "icon" }, [
                  _c("i", { staticClass: "el-icon-check" }),
                ]),
                _c("span", [_vm._v("清关后")]),
              ]
            ),
          ]),
          _c("div", { staticClass: "table" }, [
            _c(
              "div",
              { staticClass: "item", class: _vm.renderClass("PRE_CLEARANCE") },
              [
                _c(
                  "div",
                  { staticClass: "top" },
                  [
                    _c("svg-icon", {
                      attrs: { iconClass: "claerance", className: "icon" },
                    }),
                    _vm._v(" 清关前 "),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "detail" },
                  _vm._l(_vm.fileList[0], function (file, i) {
                    return _c("div", { key: i, staticClass: "child-item" }, [
                      _c("span", [_vm._v(" " + _vm._s(file.name) + " ")]),
                      _c("i", {
                        staticClass: "icon",
                        class:
                          file.status === "SUBMITTED"
                            ? "el-icon-success"
                            : "el-icon-circle-check",
                        style: {
                          color: file.status === "SUBMITTED" ? "#35BA83" : "",
                        },
                      }),
                    ])
                  }),
                  0
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "item", class: _vm.renderClass("IN_CLEARANCE") },
              [
                _c(
                  "div",
                  { staticClass: "top" },
                  [
                    _c("svg-icon", {
                      attrs: { iconClass: "claerance", className: "icon" },
                    }),
                    _vm._v(" 清关中 "),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "detail" },
                  [
                    _vm._l(_vm.fileList[1], function (file, i) {
                      return _c("div", { key: i, staticClass: "child-item" }, [
                        _c("span", [_vm._v(" " + _vm._s(file.name) + " ")]),
                        _c("i", {
                          staticClass: "icon",
                          class:
                            file.status === "SUBMITTED"
                              ? "el-icon-success"
                              : "el-icon-circle-check",
                          style: {
                            color: file.status === "SUBMITTED" ? "#35BA83" : "",
                          },
                        }),
                      ])
                    }),
                    _vm.clearanceData.inspection?.hasInspection
                      ? _c(
                          "div",
                          { staticClass: "check" },
                          _vm._l(
                            _vm.clearanceData.inspection?.list,
                            function (item, i) {
                              return _c(
                                "div",
                                { key: i, staticClass: "check-item" },
                                [
                                  _c(
                                    "span",
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/images/bill/cy-icon.png"),
                                        },
                                      }),
                                      _vm._v(" " + _vm._s(item.typeName) + " "),
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "bottom",
                                            width: "130",
                                            trigger: "hover",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { color: "#666666" },
                                            },
                                            [
                                              _c("p", [
                                                _vm._v("环节 "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "margin-left": "14px",
                                                      color: "#1D2129",
                                                    },
                                                  },
                                                  [_vm._v("清关中查验")]
                                                ),
                                              ]),
                                              _c("p", [
                                                _vm._v("凭证 "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "margin-left": "14px",
                                                      color: "#08A363",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item?.certificateFileUrl
                                                          ? "无"
                                                          : item?.certificateStatus ===
                                                            "UPLOADED"
                                                          ? "已上传"
                                                          : "待上传"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                            staticStyle: { color: "#CF4617" },
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("span", { staticClass: "date" }, [
                                    _vm._v(" " + _vm._s(item.time) + " "),
                                  ]),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "item", class: _vm.renderClass("POST_CLEARANCE") },
              [
                _c(
                  "div",
                  { staticClass: "top" },
                  [
                    _c("svg-icon", {
                      attrs: { iconClass: "claerance", className: "icon" },
                    }),
                    _vm._v(" 清关后 "),
                  ],
                  1
                ),
                _c("div", { staticClass: "detail" }, [
                  _c("div", { staticClass: "child-item" }, [
                    _c("span", [_vm._v(" 清关放行 ")]),
                    _c("i", {
                      staticClass: "icon",
                      class: _vm.clearanceData.releaseStatus?.released
                        ? "el-icon-success"
                        : "el-icon-circle-check",
                      style: {
                        color: _vm.clearanceData.releaseStatus?.released
                          ? "#35BA83"
                          : "",
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "child-item" }, [
                    _c("span", [_vm._v(" 完结 ")]),
                    _c("i", {
                      staticClass: "icon",
                      class: _vm.clearanceData.completed
                        ? "el-icon-success"
                        : "el-icon-circle-check",
                      style: {
                        color: _vm.clearanceData.completed ? "#35BA83" : "",
                      },
                    }),
                  ]),
                ]),
              ]
            ),
          ]),
          _c("div", { staticClass: "bottom" }, [
            _c("div", { staticClass: "item" }, [
              _c("img", {
                attrs: { src: require("@/assets/images/bill/qggj.png") },
              }),
              _c("div", { staticClass: "des" }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("清关轨迹")]),
                  _c("span", { staticClass: "date" }, [
                    _vm._v(
                      _vm._s(
                        _vm.clearanceData.traces?.clearanceTrace?.updateTime
                      )
                    ),
                  ]),
                ]),
                _c("p", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(_vm.clearanceData.traces?.clearanceTrace?.message)
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "item" }, [
              _c("img", {
                attrs: { src: require("@/assets/images/bill/csgj.png") },
              }),
              _c("div", { staticClass: "des" }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("船司轨迹")]),
                  _c("span", { staticClass: "date" }, [
                    _vm._v(
                      _vm._s(
                        _vm.clearanceData.traces?.shippingTrace?.updateTime
                      )
                    ),
                  ]),
                ]),
                _c("p", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(_vm.clearanceData.traces?.shippingTrace?.message)
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }